import { Component, OnInit,Input, Output, OnDestroy } from '@angular/core';
import { PlayerService } from '../services/player.service';
import { MdDialog, MdDialogRef } from '@angular/material';
import { LoggingService,ArtistService, AuthService, UserService,AlbumsService, SongsService, PlaylistService, MessagesServices } from '../../api';
import { Router,ActivatedRoute, Params} from '@angular/router';
import { Globals } from '../../app.globals';

@Component({
  selector: 'song-info',
  templateUrl: './song-info.component.html',
  styleUrls: ['./song-info.component.css']
})
export class SongInfoComponent implements OnInit, OnDestroy {
  private currentTrack: any = null;
  public is_explicit: any = null;
  private playerEventSubscriber = null;
  public dialogRef: MdDialogRef<GenericAvatarFullImageComponent>;

  constructor(private playerService: PlayerService,public dialog: MdDialog) { }

  ngOnInit() {
    if (this.playerService.isPlayingStatus() === true) {
      this.currentTrack = this.playerService.currentTrackData();
    }
    this.playerEventSubscriber = this.playerService.playerEvent.subscribe((event) => {
      if (event.type === 'track:id') {
        this.currentTrack = this.playerService.currentTrackData();
        if(this.playerService.currentTrackData()){
          this.is_explicit=this.playerService.currentTrackData().metaData.is_explicit_content;
        }
      }
    });
    
  }

  ngOnDestroy() {
    if (this.playerEventSubscriber != null) {
      this.playerEventSubscriber.unsubscribe();
    }
  }

}


@Component({
  selector: 'app-generic-avatar-full-image',
  template:`
<md-toolbar color="primary" class='w3-animate-fading1'>
  <span >Now Playing {{this.title}}</span>
</md-toolbar>
<div class='w3-animate-fading'>
  <img md-list-avatar src="{{image}}" (click)='routeToAvatarSource($event)' default-src
  />
</div> `,
  styleUrls: ['song-info.component.css']
})
export class GenericAvatarFullImageComponent implements OnInit {
  @Input() item: any;
  @Input() bigAvatarForCollectionView: boolean = false;
  @Input() bigAvatar: boolean = true;  // default size
  @Input() refresh: boolean = false;
  private image: any;
  private routeSubscriber = null;
  title:any ="";
  constructor(public dialogRef: MdDialogRef<GenericAvatarFullImageComponent>,private playerService: PlayerService, private playlistService: PlaylistService, private route: ActivatedRoute, private router: Router,
  private songService: SongsService, private albumService: AlbumsService, private artistService: ArtistService, private userService: UserService) {
  }

  ngOnInit() {
    this.processImage();
    if (this.refresh) {
      this.routeSubscriber = this.route.params.subscribe((params: any) => {
        if (params.songSlug) {
          this.songService.getSongDetailBySlug(params.songSlug).subscribe((res) => {
            this.item = res;
            this.processImage();
          });
        } else if (params.albumSlug) {
          this.albumService.getAlbumDetailsBySlug(params.albumSlug).subscribe((res) => {
            this.item = res;
            this.processImage();
          });
        } else if (params.artistSlug) {
          this.artistService.getArtistDetailsBySlug(params.artistSlug)
            .subscribe((res) => {
              this.item = res;
              this.processImage();
            });
        } else if (params.id) {
          this.playlistService.getPlaylistDetail(params.id)
            .subscribe((res) => {
              this.item = res;
              this.processImage();
            });
        } else if (params.screenname) {
          this.userService.getUserDetailsBySlug(params.screenname)
            .subscribe((res) => {
              this.item = res;
              this.processImage();
            });
        }
      });
    }
    setTimeout(()=>{
      this.dialogRef.close()
    },3000)
  }

  processImage() {
    let itemType = (typeof this.item !== 'undefined' && typeof this.item._type !== 'undefined') ? this.item._type : 'playlist';
    switch (itemType) {
      case 'album':
        if (!this.item.image || this.item.image.indexOf('mspro-photos') <= 0) {
          this.image = new Globals().domain;
          this.image += (this.item && this.item.image !== '' && this.item.image != null) ?
              this.item.image : '/images/artist_default_avatar.jpg';
        } else {
          this.image = this.item.image;
        }
        break;
      case 'playlist':
        this.image = new Globals().apiEndpoint + 'playlists/get-avatar?playlist_id=' + this.item.id + '&date=' + Date.now();
        break;
      case 'song':
        this.image = (this.item.album != null && this.item.album.image != null && this.item.album.image.trim() !== '')
            ? this.item.album.image : (this.item.artist != null && this.item.artist.image != null &&
            this.item.artist.image.trim() !== '' && this.item.artist.image != null ?
                this.item.artist.image : new Globals().domain + '/images/artist_default_avatar.jpg');
        break;
      case 'artist':
        this.image = (this.item.image && this.item.image !== '') ? this.item.image :
            new Globals().domain+ '/images/artist_default_avatar.jpg';
        break;
      case 'account':
        this.image = new Globals().apiEndpoint + 'api/user-avatar?id=' + this.item.screenname;
        break;
    }
  }

  routeToAvatarSource(event) {
    event.stopPropagation();
    event.preventDefault();
    let itemType = (typeof this.item !== 'undefined' && typeof this.item._type !== 'undefined') ? this.item._type : 'playlist';

    switch (itemType) {
      case 'song':
        if (this.item.album && this.item.album.slug) {
          this.router.navigate(['/collection', this.item.album.slug]);
        } else {
          this.router.navigate(['/song', this.item.slug]);
        }
        break;
      case 'artist':
        this.router.navigate(['/artist', this.item.slug]);
        break;
      case 'album':
        this.router.navigate(['/collection', this.item.slug]);
        break;
      case 'playlist':
        if (this.item.type != 'R') {
          this.router.navigate(['/playlist', this.item.slug]);
        }
        break;
      case 'account':
        this.router.navigate(['/account', this.item.slug]);
        break;
    }
  }

  ngOnDestroy() {
    if (this.routeSubscriber != null) {
      this.routeSubscriber.unsubscribe();
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/player/song-info/song-info.component.ts